import React from 'react';

import Icon from 'components/lib/icons/icon';

const OpenExternalIcon = props => (
  <Icon fill="none" viewBox="0 0 24 24" {...props}>
    <path
      d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path d="M15 3h6v6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    <path d="M10 14 21 3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </Icon>
);

OpenExternalIcon.propTypes = {
  ...Icon.propTypes,
};

export default OpenExternalIcon;
